import styled from "styled-components";

export const Container = styled.span<{ $height: number | string }>`
    min-height: ${({ $height }) =>
        $height === "unset" ? "unset" : `${$height}px`};
`;
